import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'list-translation-exclusions' as const;

const argumentZod = z.object({
  kind: z
    .enum(['page-field', 'collection-field', 'component-prop'])
    .describe('Which kind of translation exclusion rules to list.'),
  limit: z
    .number()
    .int()
    .min(1)
    .max(200)
    .optional()
    .describe('Max rules to return per page (1-200, default 50)'),
  cursor: z
    .string()
    .optional()
    .describe(
      'Opaque pagination cursor from a previous response nextCursor; omit for the first page'
    ),
});

export const listTranslationExclusionsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'List translation exclusion rules',
  prettyStatus: {
    executing: 'Listing translation exclusions…',
    executed: 'Listed translation exclusions',
    failed: 'Listing translation exclusions failed',
  },
  family: 'localization',
  llmTool: {
    name: toolName,
    description:
      'Lists translation exclusion rules for the current site — page fields or CMS collection fields that are excluded from translation — filtered by kind and paginated.',
    inputSchema: argumentZod,
  },
  type: 'server',
  requiredScopes: ['sites:read'],
  permission: [{resource: 'Site', action: 'read'}],
  confirmBeforeExecuting: false,
  isReadOnly: () => true,
});

export type ListTranslationExclusionsArgumentType = z.infer<typeof argumentZod>;
